// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var LoopCommand$SmartcutsMacros = require("./commands/LoopCommand.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var TypeCommand$SmartcutsMacros = require("./commands/TypeCommand.bs.js");
var ClickCommand$SmartcutsMacros = require("./commands/ClickCommand.bs.js");
var RadioCommand$SmartcutsMacros = require("./commands/RadioCommand.bs.js");
var SelectCommand$SmartcutsMacros = require("./commands/SelectCommand.bs.js");
var UploadCommand$SmartcutsMacros = require("./commands/UploadCommand.bs.js");
var CheckboxCommand$SmartcutsMacros = require("./commands/CheckboxCommand.bs.js");
var DownloadCommand$SmartcutsMacros = require("./commands/DownloadCommand.bs.js");
var URLRelatedCommands$SmartcutsMacros = require("./commands/shared/URLRelatedCommands.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");

function t_encode(v) {
  switch (v.TAG | 0) {
    case /* AddTextInputParamValue */0 :
        return [
                "AddTextInputParamValue",
                Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.t_encode, v._0)
              ];
    case /* InnerTextParamValue */1 :
        return [
                "InnerTextParamValue",
                Curry._1(ClickCommand$SmartcutsMacros.PlaybackParamValue.t_encode, v._0)
              ];
    case /* CheckboxParamValue */2 :
        return [
                "CheckboxParamValue",
                CheckboxCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* SelectInputParamValue */3 :
        return [
                "SelectInputParamValue",
                SelectCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* RadioInputParamValue */4 :
        return [
                "RadioInputParamValue",
                RadioCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* URLParamValue */5 :
        return [
                "URLParamValue",
                URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* DownloadParamValue */6 :
        return [
                "DownloadParamValue",
                DownloadCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* GoogleSheetsParamValue */7 :
        return [
                "GoogleSheetsParamValue",
                GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* LoopParamValue */8 :
        return [
                "LoopParamValue",
                LoopCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* UploadParamValue */9 :
        return [
                "UploadParamValue",
                UploadCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    case /* WithElementGroupsParamValue */10 :
        return [
                "WithElementGroupsParamValue",
                WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AddTextInputParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AddTextInputParamValue */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CheckboxParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = CheckboxCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CheckboxParamValue */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DownloadParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = DownloadCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DownloadParamValue */6,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "GoogleSheetsParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GoogleSheetsParamValue */7,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "InnerTextParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._1(ClickCommand$SmartcutsMacros.PlaybackParamValue.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InnerTextParamValue */1,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "LoopParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = LoopCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LoopParamValue */8,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "RadioInputParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = RadioCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RadioInputParamValue */4,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "SelectInputParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = SelectCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectInputParamValue */3,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "URLParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* URLParamValue */5,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "UploadParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = UploadCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UploadParamValue */9,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "WithElementGroupsParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WithElementGroupsParamValue */10,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(v) {
  return [
          "UpdateWithElementGroupsParamValue",
          Curry._1(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.Update.t_encode, v._0)
        ];
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UpdateWithElementGroupsParamValue") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.Update.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* UpdateWithElementGroupsParamValue */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(update) {
  return "UpdateWithElementGroupsParamValue(v)";
}

function apply(value, update) {
  if (value.TAG !== /* WithElementGroupsParamValue */10) {
    return value;
  }
  var func = WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.Update.apply;
  return {
          TAG: /* WithElementGroupsParamValue */10,
          _0: Curry._2(func, value._0, update._0)
        };
}

function substituteIntoCommand(command, update) {
  if (typeof command === "number") {
    return command;
  }
  if (command.TAG !== /* WithElementGroupsCommand */43) {
    return command;
  }
  var cmdVal = command._0;
  return {
          TAG: /* WithElementGroupsCommand */43,
          _0: {
            sequence: cmdVal.sequence,
            iteratorStrategy: cmdVal.iteratorStrategy,
            paginateOptions: cmdVal.paginateOptions,
            transducers: cmdVal.transducers,
            actions: Belt_Array.reduce(Belt_MapInt.toArray(update._0.actions), cmdVal.actions, (function (actions, param) {
                    var index = param[0];
                    var match = Belt_Array.get(actions, index);
                    if (match === undefined) {
                      return actions;
                    }
                    var exportTo = match._0;
                    return ArrayUtils$SmartcutsMacros.replaceAtIndex(actions, index, /* ExportTo */{
                                _0: {
                                  destination: {
                                    TAG: /* NewGoogleSheet */1,
                                    _0: {
                                      TAG: /* Resolved */0,
                                      _0: param[1]._0._0
                                    }
                                  },
                                  columns: exportTo.columns,
                                  maybeExtraColumns: exportTo.maybeExtraColumns,
                                  maybePrimayKeys: exportTo.maybePrimayKeys,
                                  snapshotOfDataExported: exportTo.snapshotOfDataExported
                                }
                              });
                  }))
          }
        };
}

var Update = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify,
  apply: apply,
  substituteIntoCommand: substituteIntoCommand
};

function stringify$1(v) {
  switch (v.TAG | 0) {
    case /* AddTextInputParamValue */0 :
        return "AddTextInputParamValue(" + (Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.stringify, v._0) + ")");
    case /* InnerTextParamValue */1 :
        return "InnerTextParamValue(" + (v._0 + ")");
    case /* CheckboxParamValue */2 :
        return "CheckboxParamValue(" + (CheckboxCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    case /* SelectInputParamValue */3 :
        return "SelectInputParamValue(" + (SelectCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    case /* RadioInputParamValue */4 :
        return "RadioInputParamValue(" + (RadioCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    case /* URLParamValue */5 :
        return "URLParamValue(" + (URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    case /* DownloadParamValue */6 :
        return "DownloadParamValue(" + (DownloadCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    case /* GoogleSheetsParamValue */7 :
        return "GoogleSheetsParamValue(" + (GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    case /* LoopParamValue */8 :
        return "LoopParamValue(" + LoopCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0);
    case /* UploadParamValue */9 :
        return "UploadParamValue(" + UploadCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0);
    case /* WithElementGroupsParamValue */10 :
        return "WithElementGroupsParamValue(" + (WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    
  }
}

function minify(x) {
  return x;
}

function fromSmartcutParam(param) {
  switch (param.TAG | 0) {
    case /* AddTextInputParam */0 :
        return {
                TAG: /* AddTextInputParamValue */0,
                _0: Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.fromParamDescriptor, param._0)
              };
    case /* InnerTextParam */1 :
        return {
                TAG: /* InnerTextParamValue */1,
                _0: Curry._1(ClickCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor, param._0)
              };
    case /* CheckboxParam */2 :
        return {
                TAG: /* CheckboxParamValue */2,
                _0: CheckboxCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* SelectInputParam */3 :
        return {
                TAG: /* SelectInputParamValue */3,
                _0: SelectCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* RadioInputParam */4 :
        return {
                TAG: /* RadioInputParamValue */4,
                _0: RadioCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* URLParam */5 :
        return {
                TAG: /* URLParamValue */5,
                _0: URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* DownloadParam */6 :
        return {
                TAG: /* DownloadParamValue */6,
                _0: DownloadCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* GoogleSheetsParam */7 :
        return {
                TAG: /* GoogleSheetsParamValue */7,
                _0: GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* LoopParam */8 :
        return {
                TAG: /* LoopParamValue */8,
                _0: LoopCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* UploadParam */9 :
        return {
                TAG: /* UploadParamValue */9,
                _0: UploadCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    case /* WithElementGroupsParam */10 :
        return {
                TAG: /* WithElementGroupsParamValue */10,
                _0: WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
              };
    
  }
}

function t__encode(v) {
  return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(t_encode, v);
}

function t__decode(v) {
  return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(t_decode, v);
}

function commandIndexAndValueTuples_encode(v) {
  return Decco.arrayToJson((function (param) {
                return [
                        Decco.intToJson(param[0]),
                        t_encode(param[1])
                      ];
              }), v);
}

function commandIndexAndValueTuples_decode(v) {
  return Decco.arrayFromJson((function (json) {
                var match = Js_json.classify(json);
                if (typeof match === "number") {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                if (match.TAG !== /* JSONArray */3) {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                var match$1 = match._0;
                if (match$1.length !== 2) {
                  return Decco.error(undefined, "Incorrect cardinality", json);
                }
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = Decco.intFromJson(v0);
                var match$3 = t_decode(v1);
                if (match$2.TAG === /* Ok */0) {
                  if (match$3.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [
                              match$2._0,
                              match$3._0
                            ]
                          };
                  }
                  var e = match$3._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = match$2._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[0]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }), v);
}

function minify$1(map) {
  return Belt_MapInt.map(map, minify);
}

function fromSmartcutParams(smartcutParams) {
  return Belt_Array.reduce(smartcutParams, undefined, (function (smartcutParamValuesByCommandIndex, paramDescriptor) {
                return Belt_MapInt.set(smartcutParamValuesByCommandIndex, paramDescriptor.firstCommandIndex, fromSmartcutParam(paramDescriptor.param));
              }));
}

function fromSmartcutParamsWithMaybeFirstUrl(maybeFirstUrl, smartcutParams) {
  return Belt_Array.reduceWithIndex(smartcutParams, undefined, (function (pvaluesByCommandIndex, paramDescriptor, index) {
                var param = paramDescriptor.param;
                if (param.TAG === /* URLParam */5 && index === 0) {
                  var match = param._0;
                  return Belt_MapInt.set(pvaluesByCommandIndex, 0, {
                              TAG: /* URLParamValue */5,
                              _0: {
                                url: OptionUtils$SmartcutsMacros.withDefault(match.originalUrl, maybeFirstUrl),
                                urlCommandType: match.urlCommandType
                              }
                            });
                }
                if (index === 0) {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Expected first param to be a url param");
                }
                var pvaluesByCommandIndex_1 = Belt_MapInt.set(pvaluesByCommandIndex, paramDescriptor.firstCommandIndex, fromSmartcutParam(param));
                return Belt_List.reduce(paramDescriptor.otherCommandIndexes, pvaluesByCommandIndex_1, (function (pvaluesByCommandIndex_2, otherCommandIndex) {
                              return Belt_MapInt.set(pvaluesByCommandIndex_2, otherCommandIndex, fromSmartcutParam(param));
                            }));
              }));
}

function preserveObjectUrlInPlaybackData(map) {
  return Promise.all(Belt_Array.map(Belt_MapInt.toArray(map), (function (param) {
                      var playbackParamValue = param[1];
                      var commandIndex = param[0];
                      if (playbackParamValue.TAG !== /* UploadParamValue */9) {
                        return Promise.resolve([
                                    commandIndex,
                                    playbackParamValue
                                  ]);
                      }
                      var match = playbackParamValue._0;
                      if (match.TAG !== /* FileObject */0) {
                        return Promise.resolve([
                                    commandIndex,
                                    playbackParamValue
                                  ]);
                      }
                      var match$1 = match._0;
                      var fileName = match$1.fileName;
                      return fetch(match$1.objectUrl).then(function (prim) {
                                    return prim.blob();
                                  }).then(function (blob) {
                                  var objectUrl$p = URL.createObjectURL(blob);
                                  return Promise.resolve([
                                              commandIndex,
                                              {
                                                TAG: /* UploadParamValue */9,
                                                _0: {
                                                  TAG: /* FileObject */0,
                                                  _0: {
                                                    objectUrl: objectUrl$p,
                                                    fileName: fileName
                                                  }
                                                }
                                              }
                                            ]);
                                });
                    }))).then(function (results) {
              return Promise.resolve(Belt_MapInt.fromArray(results));
            });
}

var ValuesByCommandIndex = {
  t__encode: t__encode,
  t__decode: t__decode,
  commandIndexAndValueTuples_encode: commandIndexAndValueTuples_encode,
  commandIndexAndValueTuples_decode: commandIndexAndValueTuples_decode,
  minify: minify$1,
  fromSmartcutParams: fromSmartcutParams,
  fromSmartcutParamsWithMaybeFirstUrl: fromSmartcutParamsWithMaybeFirstUrl,
  preserveObjectUrlInPlaybackData: preserveObjectUrlInPlaybackData
};

function substitutePlaybackValuesIntoCommandLog(commandLog, playbackValuesByCommandIndex) {
  return Belt_MapInt.reduce(playbackValuesByCommandIndex, commandLog, (function (commandLog, commandIndex, playbackParamValue) {
                var commandLog_2 = ListUtils$SmartcutsMacros.updateAt(commandIndex, (function (cmdWithContext) {
                        var contextGlobal = cmdWithContext.contextGlobal;
                        var command = cmdWithContext.command;
                        switch (playbackParamValue.TAG | 0) {
                          case /* AddTextInputParamValue */0 :
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* TypeCommand */15,
                                        _0: Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.toCommandValueForPlayback, playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* InnerTextParamValue */1 :
                              var tmp;
                              tmp = typeof command === "number" || command.TAG !== /* ClickCommand */12 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* ClickCommand */12,
                                        _0: Curry._2(ClickCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback, tmp, playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* CheckboxParamValue */2 :
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* CheckboxCommand */16,
                                        _0: CheckboxCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* SelectInputParamValue */3 :
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* SelectCommand */17,
                                        _0: SelectCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* RadioInputParamValue */4 :
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* RadioCommand */18,
                                        _0: RadioCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* URLParamValue */5 :
                              var match = playbackParamValue._0;
                              var urlCommandType = match.urlCommandType;
                              var url = match.url;
                              var tmp$1;
                              switch (urlCommandType.TAG | 0) {
                                case /* NewWindowWithUrlCommand */0 :
                                    tmp$1 = {
                                      TAG: /* NewWindowWithUrlCommand */1,
                                      _0: {
                                        url: url,
                                        title: undefined,
                                        focusStatus: urlCommandType._0
                                      }
                                    };
                                    break;
                                case /* NewTabWithUrlCommand */1 :
                                    tmp$1 = {
                                      TAG: /* NewTabWithUrlCommand */3,
                                      _0: {
                                        url: url,
                                        title: undefined,
                                        tabRef: urlCommandType._0,
                                        windowRef: urlCommandType._1,
                                        focusStatus: urlCommandType._2
                                      }
                                    };
                                    break;
                                case /* URLCommand */2 :
                                    tmp$1 = {
                                      TAG: /* URLCommand */6,
                                      _0: {
                                        url: url,
                                        title: undefined,
                                        tabRef: urlCommandType._0
                                      }
                                    };
                                    break;
                                
                              }
                              return {
                                      id: cmdWithContext.id,
                                      command: tmp$1,
                                      contextGlobal: {
                                        windowRef: contextGlobal.windowRef,
                                        tabRef: contextGlobal.tabRef,
                                        url: url,
                                        focusStatus: contextGlobal.focusStatus,
                                        title: contextGlobal.title,
                                        frame: contextGlobal.frame,
                                        windowGeometry: contextGlobal.windowGeometry,
                                        targetBoundingRect: contextGlobal.targetBoundingRect,
                                        timestamp: contextGlobal.timestamp,
                                        htmlSnapshot: contextGlobal.htmlSnapshot,
                                        screenshot: contextGlobal.screenshot,
                                        croppedScreenshot: contextGlobal.croppedScreenshot,
                                        preconditions: contextGlobal.preconditions,
                                        maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                                      }
                                    };
                          case /* DownloadParamValue */6 :
                              var tmp$2;
                              tmp$2 = typeof command === "number" || command.TAG !== /* DownloadCommand */32 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected DownloadCommand") : command._0;
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* DownloadCommand */32,
                                        _0: DownloadCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(tmp$2, playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* GoogleSheetsParamValue */7 :
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* GoogleSheetsCommand */33,
                                        _0: GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* LoopParamValue */8 :
                              var tmp$3;
                              tmp$3 = typeof command === "number" || command.TAG !== /* LoopCommand */35 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* LoopCommand */35,
                                        _0: LoopCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(tmp$3, playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* UploadParamValue */9 :
                              var tmp$4;
                              tmp$4 = typeof command === "number" || command.TAG !== /* UploadCommand */41 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* UploadCommand */41,
                                        _0: UploadCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(tmp$4, playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          case /* WithElementGroupsParamValue */10 :
                              var tmp$5;
                              tmp$5 = typeof command === "number" || command.TAG !== /* WithElementGroupsCommand */43 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                              return {
                                      id: cmdWithContext.id,
                                      command: {
                                        TAG: /* WithElementGroupsCommand */43,
                                        _0: WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(tmp$5, playbackParamValue._0)
                                      },
                                      contextGlobal: cmdWithContext.contextGlobal
                                    };
                          
                        }
                      }), commandLog);
                if (playbackParamValue.TAG !== /* URLParamValue */5) {
                  return commandLog_2;
                }
                var newUrl = playbackParamValue._0.url;
                var matchingTabRefOfUpdatedUrl = Belt_List.getExn(commandLog_2, commandIndex).contextGlobal.tabRef;
                var oldUrl = Belt_List.getExn(commandLog, commandIndex).contextGlobal.url;
                return $$Array.to_list($$Array.map((function (commandWithContext) {
                                  var contextGlobal = commandWithContext.contextGlobal;
                                  if (!(Caml_obj.caml_equal(contextGlobal.tabRef, matchingTabRefOfUpdatedUrl) && contextGlobal.url === oldUrl)) {
                                    return commandWithContext;
                                  }
                                  var command = commandWithContext.command;
                                  var tmp;
                                  if (typeof command === "number" || command.TAG !== /* FocusTabCommand */5) {
                                    tmp = command;
                                  } else {
                                    var cmdVal = command._0;
                                    tmp = {
                                      TAG: /* FocusTabCommand */5,
                                      _0: {
                                        tabRef: cmdVal.tabRef,
                                        url: newUrl,
                                        title: cmdVal.title
                                      }
                                    };
                                  }
                                  return {
                                          id: commandWithContext.id,
                                          command: tmp,
                                          contextGlobal: {
                                            windowRef: contextGlobal.windowRef,
                                            tabRef: contextGlobal.tabRef,
                                            url: newUrl,
                                            focusStatus: contextGlobal.focusStatus,
                                            title: contextGlobal.title,
                                            frame: contextGlobal.frame,
                                            windowGeometry: contextGlobal.windowGeometry,
                                            targetBoundingRect: contextGlobal.targetBoundingRect,
                                            timestamp: contextGlobal.timestamp,
                                            htmlSnapshot: contextGlobal.htmlSnapshot,
                                            screenshot: contextGlobal.screenshot,
                                            croppedScreenshot: contextGlobal.croppedScreenshot,
                                            preconditions: contextGlobal.preconditions,
                                            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                                          }
                                        };
                                }), $$Array.of_list(commandLog_2)));
              }));
}

function populateSmartcutParam(smartcutParam, playbackValue) {
  var match = smartcutParam.param;
  var param;
  switch (match.TAG | 0) {
    case /* AddTextInputParam */0 :
        if (playbackValue.TAG === /* AddTextInputParamValue */0) {
          var match$1 = playbackValue._0;
          var match$2 = match._0;
          param = {
            TAG: /* AddTextInputParam */0,
            _0: {
              targetLocator: match$1.targetLocator,
              originalLabeledAddText: match$1.labeledAddTextInput,
              playbackFormLabel: match$2.playbackFormLabel,
              enums: match$2.enums
            }
          };
        } else {
          param = smartcutParam.param;
        }
        break;
    case /* CheckboxParam */2 :
        var match$3 = match._0;
        if (match$3.originalCheckboxChoice.TAG === /* SingleCheckbox */0) {
          if (playbackValue.TAG === /* CheckboxParamValue */2) {
            var match$4 = playbackValue._0;
            param = match$4.TAG === /* SingleCheckbox */0 ? ({
                  TAG: /* CheckboxParam */2,
                  _0: {
                    originalCheckboxChoice: {
                      TAG: /* SingleCheckbox */0,
                      _0: match$4._0,
                      _1: match$4._1
                    },
                    playbackFormLabel: match$3.playbackFormLabel
                  }
                }) : smartcutParam.param;
          } else {
            param = smartcutParam.param;
          }
        } else if (playbackValue.TAG === /* CheckboxParamValue */2) {
          var checkboxGroupWithChosenValues = playbackValue._0;
          param = checkboxGroupWithChosenValues.TAG === /* SingleCheckbox */0 ? smartcutParam.param : ({
                TAG: /* CheckboxParam */2,
                _0: {
                  originalCheckboxChoice: {
                    TAG: /* CheckboxGroup */1,
                    _0: checkboxGroupWithChosenValues._0
                  },
                  playbackFormLabel: match$3.playbackFormLabel
                }
              });
        } else {
          param = smartcutParam.param;
        }
        break;
    case /* SelectInputParam */3 :
        if (playbackValue.TAG === /* SelectInputParamValue */3) {
          var match$5 = playbackValue._0;
          param = {
            TAG: /* SelectInputParam */3,
            _0: {
              targetLocator: match$5.targetLocator,
              originalLabeledValue: match$5.labeledValue,
              playbackFormLabel: match._0.playbackFormLabel
            }
          };
        } else {
          param = smartcutParam.param;
        }
        break;
    case /* RadioInputParam */4 :
        if (playbackValue.TAG === /* RadioInputParamValue */4) {
          var match$6 = playbackValue._0;
          var match$7 = match$6.labeledValue;
          var value = match$7.value.selected.value;
          var match$8 = match._0;
          var match$9 = match$8.originalLabeledValue.value;
          var options = match$9.options;
          var index = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (param, index) {
                  if (Caml_obj.caml_equal(param.value, value)) {
                    return index;
                  }
                  
                }), options);
          param = {
            TAG: /* RadioInputParam */4,
            _0: {
              targetLocator: match$6.targetLocator,
              originalLabeledValue: {
                label: match$7.label,
                value: {
                  options: options,
                  indexSelected: index !== undefined ? index : match$9.indexSelected
                }
              },
              playbackFormLabel: match$8.playbackFormLabel
            }
          };
        } else {
          param = smartcutParam.param;
        }
        break;
    case /* URLParam */5 :
        if (playbackValue.TAG === /* URLParamValue */5) {
          var match$10 = playbackValue._0;
          param = {
            TAG: /* URLParam */5,
            _0: {
              originalUrl: match$10.url,
              urlPattern: match._0.urlPattern,
              urlCommandType: match$10.urlCommandType
            }
          };
        } else {
          param = smartcutParam.param;
        }
        break;
    case /* GoogleSheetsParam */7 :
        var match$11 = match._0;
        if (match$11.TAG === /* UpdateCellParam */0) {
          if (playbackValue.TAG === /* GoogleSheetsParamValue */7) {
            var match$12 = playbackValue._0;
            var match$13 = match$11._0;
            if (match$12.TAG === /* UpdateCellParamValue */0) {
              var match$14 = match$12._0;
              param = {
                TAG: /* GoogleSheetsParam */7,
                _0: {
                  TAG: /* UpdateCellParam */0,
                  _0: {
                    spreadsheetId: match$14.spreadsheetId,
                    sheetName: match$14.sheetName,
                    colNames: match$14.colNames,
                    keyColumnIndex: match$14.keyColumnIndex,
                    keyColumnValue: match$14.keyColumnValue,
                    updatedColIndex: match$14.updatedColIndex,
                    cellUpdate: {
                      fromValue: match$13.cellUpdate.fromValue,
                      toValue: match$14.cellUpdate
                    },
                    playbackFormLabel: match$13.playbackFormLabel
                  }
                }
              };
            } else {
              param = smartcutParam.param;
            }
          } else {
            param = smartcutParam.param;
          }
        } else if (playbackValue.TAG === /* GoogleSheetsParamValue */7) {
          var match$15 = playbackValue._0;
          if (match$15.TAG === /* UpdateCellParamValue */0) {
            param = smartcutParam.param;
          } else {
            var match$16 = match$15._0;
            param = {
              TAG: /* GoogleSheetsParam */7,
              _0: {
                TAG: /* UpsertRowParam */1,
                _0: {
                  spreadsheetId: match$16.spreadsheetId,
                  sheetName: match$16.sheetName,
                  colNames: match$16.colNames,
                  keyColumnIndex: match$16.keyColumnIndex,
                  keyColumnValue: match$16.keyColumnValue,
                  rowData: match$16.rowData,
                  playbackFormLabel: match$11._0.playbackFormLabel
                }
              }
            };
          }
        } else {
          param = smartcutParam.param;
        }
        break;
    default:
      param = smartcutParam.param;
  }
  return {
          firstCommandIndex: smartcutParam.firstCommandIndex,
          otherCommandIndexes: smartcutParam.otherCommandIndexes,
          param: param
        };
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.Update = Update;
exports.stringify = stringify$1;
exports.minify = minify;
exports.fromSmartcutParam = fromSmartcutParam;
exports.ValuesByCommandIndex = ValuesByCommandIndex;
exports.substitutePlaybackValuesIntoCommandLog = substitutePlaybackValuesIntoCommandLog;
exports.populateSmartcutParam = populateSmartcutParam;
/* Util-SmartcutsMacros Not a pure module */
